// extracted by mini-css-extract-plugin
export default {"duploLogoOpaque":"History_duploLogoOpaque__tA4Tg","pageHeight":"History_pageHeight__QbZRF","historyDetails":"History_historyDetails__gFEMt","noHistory":"History_noHistory__357bO"};